export default "__VITE_ASSET__BFE4J3fI__"